import './BetradarMTStatistics.less';

import React from 'react';
import clsx from 'clsx';
import MatchStatisticsScrollable from '../../MatchStatisticsScrollable';
import { lang } from '../../../../turboLive/utils';
import { WidgetWrapper } from '../../../sportradar-widgets/WidgetWrapper';
import { SrWidgetLmtStatistics } from '../../../sportradar-widgets/SrWidgetLmtStatistics';
import { isAmericanFootbal } from '../../../utils';

function BetradarMTStatistics({ matchId, tab, streamStatistics, sportId }) {
    return (
        <MatchStatisticsScrollable>
            <WidgetWrapper>
                <SrWidgetLmtStatistics
                    matchId={matchId}
                    sportId={sportId}
                    tab={tab}
                    className={clsx('sr-statistics-widget', 'context-info-' + lang, {
                        'video-statistics': streamStatistics,
                        'betradar-mt-statistics full-height': sportId !== 40,
                        'br-custom-nfl': isAmericanFootbal(sportId)
                    })}
                />
            </WidgetWrapper>
        </MatchStatisticsScrollable>
    );
}

export default BetradarMTStatistics;
